import Head from 'next/head';
import PlainBanner from '../../components/common/PlainBanner'
import React , { Fragment } from 'react';
import {GetCoveredNotCovered} from '../../api/plan';
import { useEffect } from 'react';
import {getParamsObjectFromString} from '../../utils/index';
import Error from '../404';
import CoveredNotCovered from '../../components/covered-not-covered/CoveredNotCovered';
import { trackPage } from '../../tracking';
import { getPageViewData } from '../../utils/tracking';

export async function getServerSideProps() {
  return {
    props: { pageName: 'what-is-covered' }
  }
}

export default function Home(){
    const [pageStatus, setPageStatus] =  React.useState<any>(null)
    const [productType, setProductType] =  React.useState<string>("")
    const [categoryType, setCategoryType] =  React.useState<string>("")
    const [coveredText, setCoveredText] =  React.useState<any>(null)
    const [notCoveredText, setNotCoveredText] =  React.useState<any>([])
    const [loading,setLoading] = React.useState<boolean>(false);

    useEffect(()=>{
      trackPage('What Is Covered',{...getPageViewData()})
        let params:any = getParamsObjectFromString(window.location.href)['urlParams'];
        setLoading(true)
        GetCoveredNotCovered({
            'osid':params.osid
          }).then((res:any)=>{
              if(res.data.status){
                setProductType(res.data.product_type)
                setCategoryType(res.data.category_type)
                setCoveredText(res.data.covered_lists)
                setNotCoveredText(res.data.notcovered_lists)
                setLoading(false)
              }else{
                setPageStatus(404) 
              }
          })
    },[])

    return(
        pageStatus=== null ?
        <Fragment>
        <div data-loading={loading} data-fullpage={loading}>
        </div>
        <Head>
        <title>{}</title>
        <link rel="icon" href="/favicon.ico" />
        </Head>
        <PlainBanner className="" title={`Onsitego ${productType} For Your ${categoryType}`} />
        <CoveredNotCovered coveredText={coveredText} notCoveredText={notCoveredText}/>
        </Fragment>
        :
        <Error />
    )
}